module.exports = __webpack_public_path__ + "img/no-data.92d50c31.svg";